import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es demasiado técnico para mis alumnos?',
    a: 'No. Tiene tres niveles dentro de cada tomo: básico, intermedio y avanzado. Vos elegís el nivel para cada grupo.'
  }, {
    q: '¿Necesito equipos de laboratorio para las actividades?',
    a: 'No. El Bono 1 incluye alternativas de bajo costo — disco Secchi casero, sistemas de filtración con botellas recicladas, experimentos con herramientas de cocina.'
  }, {
    q: '¿Puedo editar los materiales?',
    a: 'Sí. Todo en formatos editables para adaptarlo a las normativas y contextos de tu institución.'
  }, {
    q: '¿Funciona para cursos cortos?',
    a: 'Sí. El Bono 4 incluye versión de 6 meses y adaptaciones para talleres intensivos.'
  }, {
    q: '¿Qué pasa si ya conozco acuicultura?',
    a: 'Este no es un curso para aprender acuicultura — es la arquitectura didáctica para enseñarla. Tus conocimientos más este sistema igual a tus mejores clases.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'En menos de 5 minutos después del pago.'
  }, {
    q: '¿Para quién es el Mega Banco Pro?',
    a: 'Para docentes con grupos avanzados, capacitadores en empresas del sector y coordinadores que quieren formación de nivel consultoría profesional.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en USD. El cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento. Pagás en pesos, soles, quetzales o tu moneda local sin conversión manual.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. El material está pensado para toda Latinoamérica: trucha en zonas frías, tilapia en el trópico, camarón en la costa, cachama en ríos cálidos.'
  }, {
    q: '¿Qué pasa si no me gusta o no me sirve?',
    a: 'Tenés 7 días de garantía total. Si revisás el material y sentís que no es lo que esperabas, escribinos y te devolvemos el 100% del dinero. Sin preguntas.'
  }];
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase mb-5 leading-tight" data-id="element-66">
          Preguntas <span className="green-highlight" data-id="element-67">Frecuentes</span>
        </h2>
        <div className="space-y-2.5" data-id="element-68">
          {faqs.map((faq, i) => <div key={i} className={`bg-white rounded-lg border-2 ${openIndex === i ? 'border-brand-green' : 'border-brand-navy/20'} overflow-hidden transition-all`} data-id="element-69">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center gap-3 focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-70">
                <span className={`font-display font-bold text-sm md:text-base uppercase leading-tight ${openIndex === i ? 'text-brand-navy' : 'text-brand-navy/80'}`} data-id="element-71">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-green shrink-0" strokeWidth={3} data-id="element-72" /> : <Plus className="w-5 h-5 text-brand-navy shrink-0" strokeWidth={3} data-id="element-73" />}
              </button>
              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-74">
                <p className="text-sm md:text-base text-brand-mute font-medium leading-snug border-t border-brand-line pt-2.5" data-id="element-75">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}